var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ekkHeader"}},[_c('div',{staticClass:"ekk-header-title"},[_vm._v("梵木智能便利店")]),_c('div',{staticClass:"ekk-header-login"},[_c('div',{staticClass:"ekk-header-logout hover:text-blue-500",on:{"click":_vm.handleLoginOut}},[_vm._v("退出登录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }